import React from "react";
import DropdownInput from "../DropdownInput/DropdownInput";
import "react-dropdown/style.css";
import "../DropdownInput/DropdownInput.scss";
import CustomInput from "../CustomInput";
import "./AdditionalInput.scss";

interface Props {
  options: string[];
  setOptions?: (option: string[]) => void;
}

export default function AdditionalInput({ options, setOptions }: Props) {
  return (
    <div>
      <div className="AdditionalElement">
        <DropdownInput
          options={options}
          setOptions={setOptions}
          placeholder={"Оберiть поле"}
          title="Додати нове поле"
          radio={false}
        />
        <CustomInput placeholder="Введіть значення" title="Значення поля" />
      </div>
    </div>
  );
}
